import { render, staticRenderFns } from "./NtfyMessageTemporary.vue?vue&type=template&id=05b83a96&xmlns%3Amailto=http%3A%2F%2Fwww.w3.org%2F1999%2Fxhtml&"
import script from "./NtfyMessageTemporary.vue?vue&type=script&lang=js&"
export * from "./NtfyMessageTemporary.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports